class Placeholders
  @init: () ->
    $('[placeholder]').each () ->
      placeholder = $(this).attr('placeholder')
      # $(this).attr('onfocus', 'this.placeholder=""')
      # $(this).attr('onblur', 'this.placeholder="' + placeholder + '"')

export default Placeholders
